import React from 'react';
import Navbar from 'components/navbar';
import { Outlet } from 'react-router-dom';

const FdpScreenHoc = () => {
  return (
    <div>
      <Navbar heading="FDP" searchComponent={<></>} progressComponent={<></>} />
      <Outlet />
    </div>
  );
};

export default FdpScreenHoc;
